import {Directive, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {BankAccountType} from '../../bank-account-types/bank-account-type/bank-account-type';
import {BankAccountTypesService} from '../../bank-account-types/bank-account-types.service';
import {AppealReopenReason} from '../../appeal-reopen-reasons/appeal-reopen-reason/appeal-reopen-reason';
import {Bank} from './bank';
import {BanksService} from '../banks.service';
declare var $: any;
@Directive({
  selector: '[appBank]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BankDirective),
    multi: true
  }]
})
export class BankDirective implements ControlValueAccessor, OnInit {

  @Input() private item: Bank;
  @Input() private disabled = false;
  select2: any;
  @Output() bankSelected: EventEmitter<any> = new EventEmitter();

  constructor(private el: ElementRef, private service: BanksService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Banks',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;
          that.service.getAll().subscribe((ret: Array<BankAccountType>) => {
            success(ret);
          });

        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.name,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.item = JSON.parse(e.params.data.id);
      that.propagateChange(that.item);
      const selectedBank = JSON.parse(e.params.data.id);
      that.bankSelected.emit(selectedBank);

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.item = null;
      that.propagateChange(that.item);
      that.bankSelected.emit(null);
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(item: Bank): void {

    this.item = item;
    this.propagateChange(this.item);
    const that = this;
    if (this.item !== undefined && this.item !== null) {
      const option = new Option(item.name, JSON.stringify(item), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.item;
  }

  set value(v: any) {
    if (v !== this.item) {
      this.item = v;
      this.propagateChange(v);
    }
  }

}
